export const MILLIS_IN_SECOND = 1000;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * MINUTES_IN_HOUR;
export const DAYS_IN_YEAR = 365;
export const DAYS_IN_6_MONTHS = 180;
export const DAYS_IN_3_MONTHS = 90;
export const DAYS_IN_4_WEEKS = 28;
export const DAYS_IN_WEEK = 7;
export const TODAY = 0;
export const MONTHS_IN_YEAR = 12;
export const METERS_IN_KILOMETER = 1000;

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
